import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { profileService } from "../services/apiService";
import { useAuth } from "../hooks/useAuth";

const getInitials = (name) => {
  if (!name) return "U";
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0].toUpperCase())
    .join("")
    .slice(0, 3);
};

const ProfileMenu = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [initials, setInitials] = useState(() => {
    const cached = localStorage.getItem("userFullName");
    return cached ? getInitials(cached) : "U";
  });

  useEffect(() => {
    const cached = localStorage.getItem("userFullName");
    if (!cached) {
      profileService.getProfile().then((data) => {
        const name = data?.personalDetailsResource?.name;
        if (name) {
          localStorage.setItem("userFullName", name);
          setInitials(getInitials(name));
        }
        if (data?.gstin) {
          localStorage.setItem("gstin", data.gstin);
        }
      }).catch(() => {});
    }
  }, []);

  const handleEditProfile = async () => {
    try {
      const profileData = await profileService.getProfile();
      navigate("/profile", { state: profileData });
    } catch (error) {
      console.error("Error fetching profile:", error);
      alert("Unable to load profile details. Please try again.");
    }
  };

  const handleLogout = async () => {
    localStorage.removeItem("userFullName");
    await logout();
  };

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="relative inline-block ml-2 z-50">
      <button
        onClick={() => setMenuOpen(!menuOpen)}
        className="w-9 h-9 rounded-full bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white font-bold text-xs shadow border-2 border-blue-300"
      >
        {initials}
      </button>

      {menuOpen && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setMenuOpen(false)} />
          <div className="absolute right-0 mt-2 w-44 z-50 bg-white border border-blue-200 rounded-lg shadow-lg">
            <button
              onClick={() => { setMenuOpen(false); handleEditProfile(); }}
              className="w-full text-left px-4 py-2.5 text-sm text-blue-700 hover:bg-blue-50 rounded-t-lg"
            >
              <i className="fas fa-user-edit mr-2"></i>Edit Profile
            </button>
            <button
              onClick={() => { setMenuOpen(false); handleLogout(); }}
              className="w-full text-left px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 rounded-b-lg"
            >
              <i className="fas fa-sign-out-alt mr-2"></i>Logout
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default ProfileMenu;
